<template>
  <!--
    The main vue-app where everything else is put into.
  -->
  <div>
    <LoadingPlaceholder v-if="!isReady" />

    <div
      v-else
      class="appContainer"
    >
      <div
        v-if="loggedIn"
        class="m-grid m-grid--hor m-grid--root m-page"
      >
        <environment />
        <Head />
        <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
          <Menu />
          <div class="m-grid__item m-grid__item--fluid m-wrapper">
            <router-view />
          </div>
        </div>
      </div>
      <div
        v-else
        class="loginContainer"
      >
        <Login />
      </div>
      <vue-snotify />
    </div>
  </div>
</template>

<script>
import { authenticationMixin } from '@/mixins/authenticationMixin';
import FreshdeskWidget from './plugins/FreshdeskWidget.js';
import { shouldAutoLogin, markAutoLoginAttempt, clearAutoLoginAttempt, hasAutoLoginParam, stripAutoLoginParam } from './plugins/autoLogin.js';
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: {
    Menu: () => import('@/components/Base/Menu.vue'),
    Head: () => import('@/components/Base/Head.vue'),
    Login: () => import('@/components/Base/Login.vue'),
    Environment: () => import('@/components/Base/Environment.vue')
  },
  mixins: [
    authenticationMixin
  ],
  data () {
    return {
      isReady: false,
    }
  },
  metaInfo () {
    return {
      titleTemplate: this.title,
    }
  },
  computed: {
    title () {
      if (this.store_getEnvironment) {
        return `%s - ${ this.store_getEnvironment.toLowerCase() === "production" ? '' : this.store_getEnvironment } - METIS`;
      }
      return `METIS`;
    },
    ...mapGetters([ 'store_getEnvironment' ])
  },
  watch:{
    $route () {
      this.authenticationCheckCredentials();
    },
    '$i18n.locale' () {
      FreshdeskWidget.install(this.$i18n.locale);
      setTimeout(() => {
         let user = this.authenticationGetUser();
        FreshdeskWidget.identify(user.decodedPayload.email, user.decodedPayload.name);
      }, 2000);
    }
  },  
  beforeMount () {
    this.loadUserFromLocalStorage().then((user) => {

      //If user already available in local storage
      if (user !== null) {
        if (this.authenticationCheckCredentials()) {
          this.finishAutoLogin();
          FreshdeskWidget.install(this.$i18n.locale);
          setTimeout(() => {
            let user = this.authenticationGetUser();
            FreshdeskWidget.identify(user.decodedPayload.email, user.decodedPayload.name);
          }, 2000);
          this.$nextTick(() => {
            this.isReady = true;
          });
          return;
        }
      }

      //Check is redirect from Identity Service
      this.checkIsRedirectFromIdentityService().then(() => {
        if(this.authenticationCheckCredentials()) {
          clearAutoLoginAttempt();
          FreshdeskWidget.install(this.$i18n.locale);
          setTimeout(() => {
            let user = this.authenticationGetUser();
            FreshdeskWidget.identify(user.decodedPayload.email, user.decodedPayload.name);
          }, 2000);
        }
        else {
          //?autologin=1: skip the login button, unless a valid token just lacks permissions (logout is running)
          if (!this.authenticationHasValidToken() && shouldAutoLogin({ search: window.location.search, hash: window.location.hash })) {
            markAutoLoginAttempt();
            this.authenticationLogin(`${window.location.pathname}${window.location.search}`).then((started) => {
              //redirect failed (e.g. Keycloak unreachable): show the normal login button instead of a blank page
              if (!started) {
                this.storeReturnPath();
                this.showApp();
              }
            });
            return;
          }
          this.storeReturnPath();
        }
        this.showApp();
      });
    });
  },
  methods: {
    //remember the current page to return to after login
    storeReturnPath () {
      let route = this.$route && this.$route.fullPath
        ? this.$route.fullPath
        : `${window.location.pathname}${window.location.search}`;
      sessionStorage.setItem('reff', stripAutoLoginParam(route) || '/');
    },
    showApp () {
      var sessionItem = sessionStorage.getItem('reff') || '/';
      if (this.$route.fullPath !== sessionItem) {
        this.$router.push(sessionItem);
      }
      this.$nextTick(() => {
        this.isReady = true;
      });
    },
    //already logged in: drop the autologin param from the url
    finishAutoLogin () {
      clearAutoLoginAttempt();
      if (hasAutoLoginParam(window.location.search)) {
        this.$router.replace(stripAutoLoginParam(`${window.location.pathname}${window.location.search}`)).catch(() => null);
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
.appContainer {
  height: 100%;
}
.loginContainer {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

select.k-textbox {
  width: auto !important;
}
</style>
